<template>
    <div class="page" v-if="!isStarted">
        <component :is="compiledStarterScreen" />
    </div>
    <div class="page" v-else>
        <div class="logo fade">
            <a href="https://samgk.ru" target="_blank"><img :src="require('@/assets/images/logo.png')" alt=""></a>
        </div>
        <div class="w-[90%] max-w-xl m-auto">
            <div class="quiz-module-card w-full fade" :class="currentQuiz.color">
                <div class="quiz-module-toolbar">
                    <button class="quiz-module-toolbar-button hover:animate-pulse" @click="ToQuizList">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </button>
                    <button class="quiz-module-toolbar-button hover:animate-pulse ml-2 mr-auto" @click="ToQuizQR">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                            <path fill-rule="evenodd" d="M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 013 9.375v-4.5zM4.875 4.5a.375.375 0 00-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.375-.375h-4.5zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 01-1.875-1.875v-4.5zm1.875-.375a.375.375 0 00-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.375-.375h-4.5zM6 6.75A.75.75 0 016.75 6h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75A.75.75 0 016 7.5v-.75zm9.75 0A.75.75 0 0116.5 6h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 013 19.125v-4.5zm1.875-.375a.375.375 0 00-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 00.375-.375v-4.5a.375.375 0 00-.375-.375h-4.5zm7.875-.75a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm6 0a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zM6 16.5a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm9.75 0a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm-3 3a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75zm6 0a.75.75 0 01.75-.75h.75a.75.75 0 01.75.75v.75a.75.75 0 01-.75.75h-.75a.75.75 0 01-.75-.75v-.75z" clip-rule="evenodd" />
                        </svg>
                    </button>
                    <div class="quiz-module-toolbar-image">
                        <img :src="currentQuiz.image" alt="">
                    </div>
                    <p class="quiz-module-toolbar-text">{{CountCompletedModules()}}/{{currentQuiz.modules !== undefined && currentQuiz.modules !== null ? currentQuiz.modules.length : 0}}</p>
                </div>
                <p class="quiz-module-card-title">{{currentQuiz.title}}</p>
                <p class="quiz-module-card-description">{{currentQuiz.description}}</p>
                <div class="quiz-module-card-body">
                    <p class="title-sm ml-3 mt-2">Модули</p>
                    <div class="module-list mt-3" v-if="currentQuiz.modules !== undefined && currentQuiz.modules !== null && currentQuiz.modules.length > 0">
                        <div class="module-container" v-for="(mod, index) in currentQuiz.modules" :key="'module_'+index" @click="ToModule(index)">
                            <div class="flex flex-row items-center">
                                <p class="text-success font-bold" v-if="IsCompleted(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </p>
                                <p class="module-title">{{mod.title}}</p>
                            </div>
                            <p class="module-description">{{mod.description}}</p>
                            <p class="module-arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                </svg>
                            </p>
                        </div>
                    </div>
                    <p class="subtitle text-center" v-else>Этот раздел пустой</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {markRaw, defineComponent, compile} from "vue"

export default {
    data() {
        return {
            isStarted: false,
            currentQuizID: Number(this.$route.params.id),
            currentQuiz: null,
            compiledStarterScreen: null
        }
    },
    methods: {
        ToModule(id) {
            this.$router.push({name: "QuizModule", params: {id: this.currentQuizID, modID: id}})
        },
        ToQuizList() {
            this.$router.push({name: "QuizList"})
        },
        ToQuizQR() {
            let link = this.$router.resolve({name: "QuizQR", params: {id: this.currentQuizID}}).href
            window.open(link, '_blank')
        },
        CopyData(data) {
            return data !== undefined ? JSON.parse(JSON.stringify(data)) : null
        },
        IsStarted() {
            this.$store.commit("updateQuizes")
            let quizesData = this.CopyData(this.$store.state.quizes)

            if (quizesData !== null
                && quizesData[this.currentQuizID] !== undefined 
                && quizesData[this.currentQuizID] !== null 
                && quizesData[this.currentQuizID].quizData !== undefined
                && quizesData[this.currentQuizID].quizData !== null)
                return true

            return false
        },
        CountCompletedModules() {
            let quizesData = this.CopyData(this.$store.state.quizes)

            let count = 0

            if (quizesData !== null
                && quizesData[this.currentQuizID] !== undefined 
                && quizesData[this.currentQuizID] !== null 
                && quizesData[this.currentQuizID].modules !== undefined
                && quizesData[this.currentQuizID].modules !== null)
                for (var i in quizesData[this.currentQuizID].modules) {
                    var module = quizesData[this.currentQuizID].modules[i]
                    if (module.points !== undefined && module.points !== null) count += 1
                }

            return count
        },
        IsCompleted(id) {
            let quizesData = this.CopyData(this.$store.state.quizes)

            if (quizesData == null
                || quizesData[this.currentQuizID] == undefined 
                || quizesData[this.currentQuizID] == null 
                || quizesData[this.currentQuizID].modules == undefined
                || quizesData[this.currentQuizID].modules == null
                || quizesData[this.currentQuizID].modules[id] == undefined
                || quizesData[this.currentQuizID].modules[id] == null)
                return false

            if (quizesData[this.currentQuizID].modules[id].points !== undefined 
                && quizesData[this.currentQuizID].modules[id].points !== null)
                return true

            return false
        }
    },
    async created() {
        let res = await this.$root.GetQuizes()
        this.currentQuiz = res[Number(this.$route.params.id)]

        if (this.currentQuiz == undefined || this.currentQuiz == null) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.currentQuiz.status == 0) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.currentQuiz.status == 2) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.IsStarted() && this.$route.name == "Quiz") {
            this.$router.push({name: "QuizModules", params: {id: this.currentQuizID}})
            return
        }
        if (!this.IsStarted() && this.$route.name == "QuizModules") {
            this.$router.push({name: "Quiz", params: {id: this.currentQuizID}})
            return
        }
        this.isStarted = this.IsStarted()
        let currentQuizID = this.currentQuizID
        this.compiledStarterScreen = markRaw(defineComponent({
            data() {
                return {
                    quizData: {}
                }
            },
            methods: {
                ValidateField(key) {
                    let value = this.GetQuizData(key)

                    if (value == null) return false

                    if (typeof value === 'string')
                        return value.trim() != ""

                    return true
                },
                Start() {
                    this.$store.commit("updateQuizes")
                    let quizesData = this.$parent.CopyData(this.$store.state.quizes)

                    quizesData = quizesData == null ? {} : quizesData

                    quizesData[currentQuizID] = {
                        quizData: this.quizData
                    }

                    this.$store.commit("setQuizes", quizesData)

                    this.$router.push({name: "QuizModules", params: {id: currentQuizID}})
                },
                SetQuizData(key, value) {
                    this.quizData[key] = value
                },
                GetQuizData(key) {
                    let splittedKey = key.split(".")

                    if (splittedKey.length < 1) return null

                    let temp = this.$parent.CopyData(this.quizData)

                    for (var i in splittedKey) {
                        var tempKey = splittedKey[i]
                        if (temp[tempKey] == undefined) return null
                        temp = this.$parent.CopyData(temp[tempKey])
                    }

                    return temp
                }
            },
            render: compile(this.currentQuiz.startPage)
        }))
    },
}
</script>